const paperProductsKeys = [
    'NationalDelivery',
    'HomeDelivery',
    'SubscriptionCard',
];
const guardianWeeklyKeys = [
    'GuardianWeeklyDomestic',
    'GuardianWeeklyRestOfWorld',
];
const contributionProductKeys = [
    'SupporterPlus',
    'Contribution',
    'OneTimeContribution',
];
const printProductsKeys = [
    ...paperProductsKeys,
    ...guardianWeeklyKeys,
];
export function isPrintProduct(productKey) {
    return printProductsKeys.includes(productKey);
}
export function isContributionOnlyProduct(productKey) {
    return productKey === 'Contribution';
}
export function isContributionProduct(productKey) {
    return contributionProductKeys.includes(productKey);
}
export function isGuardianWeeklyProduct(productKey) {
    return guardianWeeklyKeys.includes(productKey);
}
export function isGuardianWeeklyGiftProduct(productKey, ratePlanKey) {
    return (isGuardianWeeklyProduct(productKey) &&
        ['ThreeMonthGift', 'OneYearGift'].includes(ratePlanKey));
}
export function isGuardianWeeklyOrTierThreeProduct(productKey) {
    return (isGuardianWeeklyProduct(productKey) || ['TierThree'].includes(productKey));
}
